import tvgConf from "@tvg/conf";
import { get } from "lodash";
import { EnvKey, KeysList } from "./types";

const KEYS_LIST: KeysList = {
  qa: {
    tvg: {
      web: "client-jnKlEobFN5VznDxIalCa79Cxx11b03PZ"
    }
  },
  staging: {
    tvg: {
      web: "client-DybuPFka20yiegOqJwv7R3t4TZBFgvzd"
    }
  },
  production: {
    tvg: {
      web: "client-QWuoGcQ3o0cUyK9IvZLiB3BZZ2eSa6QN"
    }
  }
};

const { environment = "production" } = tvgConf();

const mapEnvironment = (env: string) => {
  if (env === "aws-stg" || env === "staging") return "staging";
  if (env === "aws-prd" || env === "production") return "production";
  if (env === "aws-int" || env === "qa") return "qa";
  return "production";
};

export const ENV_KEYS: EnvKey = get(
  KEYS_LIST,
  mapEnvironment(environment),
  KEYS_LIST.production
);
